module.exports = __webpack_public_path__ + "img/hutaomu2.53fd5f41.jpg";